export interface Review {
  id: string;
  author: string;
  role: string;
  rating: number;
  title: string;
  content: string;
  date: string;
}

export interface Movie {
  id: string;
  title: string;
  enTitle: string;
  year: number;
  director: string;
  cast: string[];
  genres: string[];
  region: string;
  duration: number;
  rating: number;
  tagline: string;
  poster: string;
  backdrop: string;
  synopsis: string;
  tags: string[];
  featured?: boolean;
  reviews: Review[];
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "聚会的目的",
    enTitle: "The Purpose of a Gathering",
    year: 2024,
    director: "林思远",
    cast: ["周砚清", "苏晚", "陈之衡", "宋宁"],
    genres: ["剧情", "悬疑", "都市"],
    region: "中国大陆",
    duration: 118,
    rating: 8.6,
    tagline: "一场看似平常的老友聚会，藏着每个人都不愿说破的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20group%20of%20friends%20gathered%20around%20a%20dinner%20table%20at%20night%2C%20moody%20dramatic%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rooftop%20gathering%20at%20dusk%2C%20city%20skyline%20bokeh%20lights%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20atmospheric%20lighting%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-01&orientation=landscape",
    synopsis:
      "毕业十年的老同学在一间老餐厅重聚，表面上是庆祝，实则每个人心里都揣着一件未了的心事。随着夜色渐深，回忆与现实交错，原本轻松的氛围被一次次无意间的追问打破。组织者程屿始终沉默，他似乎知道这场聚会真正的目的，却迟迟不肯开口。当最后一张旧照片被放到桌面，所有伪装都开始崩塌——他们究竟是为重逢而来，还是为了某件必须当面了结的往事？",
    tags: ["老友重聚", "群像", "悬念", "都市情感"],
    featured: true,
    reviews: [
      {
        id: "1-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 9.0,
        title: "把一场饭局拍成了十年的人生",
        content:
          "《聚会的目的》最厉害的地方在于，它几乎全部发生在一张餐桌旁，却拍出了十年的呼吸。导演用极克制的镜头语言，把每个人的表情都当成台词。你以为在看别人吃饭，其实是在看自己这些年的逃避与妥协。",
        date: "2024-09-18",
      },
      {
        id: "1-2",
        author: "观众·许一凡",
        role: "普通影迷",
        rating: 8.5,
        title: "后半程的沉默比任何对白都响",
        content:
          "前半段有点慢热，但从照片被摆上桌的那一刻起，整个影院都安静了。那种大家都懂、却谁都不肯先说的尴尬，被拍得真实到窒息。散场后我久久没说话，脑子里全是自己那些没赴过的约。",
        date: "2024-09-25",
      },
      {
        id: "1-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.4,
        title: "群像戏的调度教科书",
        content:
          "四位主演的表演各有层次，尤其是程屿这个角色，几乎全靠眼神完成情绪转折。剧本对『目的』二字的处理很高级，没有给标准答案，而是把解释权交还给观众。这是一部值得二刷的电影。",
        date: "2024-10-02",
      },
    ],
  },
  {
    id: "2",
    title: "未寄出的信",
    enTitle: "The Unsent Letter",
    year: 2023,
    director: "郑怀舟",
    cast: ["林知夏", "顾行", "秦朗"],
    genres: ["剧情", "爱情", "文艺"],
    region: "中国大陆",
    duration: 104,
    rating: 8.2,
    tagline: "有些话写下来，却永远没有寄出的勇气。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20single%20folded%20letter%20on%20a%20wooden%20desk%20by%20a%20rainy%20window%2C%20moody%20dramatic%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20empty%20room%20with%20letters%20scattered%20near%20a%20rainy%20window%2C%20soft%20moody%20light%2C%20deep%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-02&orientation=landscape",
    synopsis:
      "一封被压在抽屉底层的信，连接起两个错过多年的名字。整理旧物的插画师偶然读到了这封从未寄出的告白，信里的字迹熟悉得让她心慌。她开始循着信中的线索寻找写信人，却在一次次的擦肩中意识到，有些人不是没遇见，而是每次都差了一点勇气。",
    tags: ["书信", "暗恋", "遗憾", "慢节奏"],
    reviews: [
      {
        id: "2-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.3,
        title: "温柔得像一场迟到的雨",
        content:
          "影片节奏很慢，但慢得有理由。那些没说出口的话，最终都落进了雨声里。摄影极美，窗、纸、光三种元素被反复使用，构成了一种独特的情感语法。",
        date: "2023-11-12",
      },
      {
        id: "2-2",
        author: "观众·白露",
        role: "普通影迷",
        rating: 8.0,
        title: "看完想给某个人发条消息",
        content:
          "很久没有一部爱情片能让我这么安静地看完。它不靠煽情，而是靠细节一点点渗透。结尾那封终究没寄出的信，反而比寄出去更动人。",
        date: "2023-11-20",
      },
      {
        id: "2-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.1,
        title: "一次关于勇气的温和叩问",
        content:
          "电影把『遗憾』处理得很有分寸，没有讨好观众。两位主角的表演内敛细腻，尤其是眼神戏，值得反复品味。",
        date: "2023-12-01",
      },
    ],
  },
  {
    id: "3",
    title: "午夜来客",
    enTitle: "Midnight Visitor",
    year: 2024,
    director: "许格",
    cast: ["程野", "白栖", "罗骁", "姜禾"],
    genres: ["悬疑", "犯罪", "惊悚"],
    region: "中国大陆",
    duration: 112,
    rating: 8.4,
    tagline: "敲门声响起时，这个家就不再只属于他们。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20silhouette%20standing%20at%20a%20dim%20doorway%20at%20midnight%2C%20moody%20tense%20lighting%2C%20deep%20navy%20blue%20and%20cold%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dark%20apartment%20hallway%20lit%20by%20a%20single%20lamp%20at%20midnight%2C%20long%20shadows%2C%20deep%20navy%20tones%2C%20tense%20atmosphere%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-03&orientation=landscape",
    synopsis:
      "一对独居夫妻的平静夜晚被一阵陌生的敲门声打破。门外站着一个自称找错门的人，却对屋内的摆设了如指掌。当防备与怀疑不断升级，真相一层层剥开：这位『午夜来客』带来的，不只是打扰，还有一段被刻意掩埋的过往。究竟谁才是真正的闯入者？",
    tags: ["密室", "反转", "心理博弈", "紧张感"],
    reviews: [
      {
        id: "3-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.5,
        title: "把紧张感压在一声敲门里",
        content:
          "整部电影的张力几乎全靠空间与声音营造，成本不高，但氛围极稳。反转不算新鲜，却胜在执行干净利落，每个伏笔都收了回来。",
        date: "2024-08-08",
      },
      {
        id: "3-2",
        author: "观众·尹澈",
        role: "悬疑片爱好者",
        rating: 8.2,
        title: "结局二刷才看懂",
        content:
          "第一次看以为只是普通的入室惊悚，第二次才发现开头那个细节早就暗示了结局。剧本的严谨程度让人服气。",
        date: "2024-08-19",
      },
      {
        id: "3-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.4,
        title: "小成本悬疑的漂亮示范",
        content:
          "四个演员、一间房子，却拍出了窒息感。表演克制，剪辑精准，是国内惊悚类型片里难得清醒的一部。",
        date: "2024-09-01",
      },
    ],
  },
  {
    id: "4",
    title: "城市的另一面",
    enTitle: "The Other Side of the City",
    year: 2022,
    director: "方岐",
    cast: ["贺铭", "温言", "洛川"],
    genres: ["剧情", "犯罪", "都市"],
    region: "中国大陆",
    duration: 126,
    rating: 8.0,
    tagline: "同一座城市，白天和夜晚属于完全不同的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lone%20figure%20walking%20down%20a%20neon%20city%20street%20at%20night%2C%20moody%20urban%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rainy%20city%20street%20at%20night%20with%20reflections%20and%20distant%20lights%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20atmosphere%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-04&orientation=landscape",
    synopsis:
      "一名夜班出租车司机在一晚之内载过形形色色的乘客，也无意间卷进了一桩被所有人忽略的失踪案。当白日的秩序与夜晚的灰色地带相互交叠，他逐渐发现，这座城市里每个人都只看见了自己愿意看的那一面。",
    tags: ["城市", "夜行", "群像", "现实"],
    reviews: [
      {
        id: "4-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.0,
        title: "一封写给夜晚的情书",
        content:
          "影片用一夜的车程串起多个人物的命运，结构精巧。它不急于审判谁，而是平静地展示城市的两副面孔，克制而有力。",
        date: "2022-10-15",
      },
      {
        id: "4-2",
        author: "观众·周牧",
        role: "普通影迷",
        rating: 7.9,
        title: "看完想在城市里走一走",
        content:
          "摄影是真的好，雨夜的灯光反射拍得很有味道。故事偶尔松散，但整体气质很迷人，适合安静的时候看。",
        date: "2022-10-28",
      },
      {
        id: "4-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.1,
        title: "用一座城市谈人的孤独",
        content:
          "群像叙事容易失焦，但本片靠一条清晰的悬疑线把它们缝在了一起。结尾留白处理得恰到好处，余味很长。",
        date: "2022-11-05",
      },
    ],
  },
  {
    id: "5",
    title: "春天不回来",
    enTitle: "Spring Won't Return",
    year: 2023,
    director: "夏之泠",
    cast: ["温书", "何以琛", "宁安"],
    genres: ["爱情", "文艺", "青春"],
    region: "中国大陆",
    duration: 98,
    rating: 7.8,
    tagline: "有些季节一旦错过，就真的不会再回来。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20two%20young%20people%20apart%20on%20a%20spring%20street%20with%20blossoms%2C%20soft%20nostalgic%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20quiet%20spring%20street%20lined%20with%20blossoming%20trees%20in%20soft%20afternoon%20light%2C%20warm%20amber%20and%20navy%20tones%2C%20nostalgic%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-05&orientation=landscape",
    synopsis:
      "两个在小城长大的年轻人，约定一起考去远方，却在那个春天各奔东西。多年后重逢，他们才敢承认，当年没说出口的告别，其实早就写在了季节里。",
    tags: ["青春", "小城", "告别", "成长"],
    reviews: [
      {
        id: "5-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 7.8,
        title: "青春片的克制表达",
        content:
          "没有狗血的争吵，也没有刻意的煽情，影片把成长的阵痛藏在日常的细枝末节里。两位主演的青涩感恰到好处。",
        date: "2023-04-20",
      },
      {
        id: "5-2",
        author: "观众·苏芮",
        role: "普通影迷",
        rating: 7.7,
        title: "想起了自己的那个春天",
        content:
          "看完有点怅然。它讲的不是爱情，而是年少时那种以为还有很久、结果一转身就没了的时间。",
        date: "2023-04-30",
      },
      {
        id: "5-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 7.9,
        title: "季节即命运",
        content:
          "用四季隐喻人物的关系变化，是本部影片最聪明的设计。摄影清新，配乐克制，整体气质干净。",
        date: "2023-05-06",
      },
    ],
  },
  {
    id: "6",
    title: "迷雾码头",
    enTitle: "Foggy Pier",
    year: 2021,
    director: "陆沉",
    cast: ["顾南舟", "沈砚", "林暮"],
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    duration: 121,
    rating: 7.9,
    tagline: "雾散之后，码头上的每个人都要面对自己的选择。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lonely%20foggy%20harbor%20pier%20with%20dim%20lights%2C%20mysterious%20moody%20lighting%2C%20deep%20navy%20blue%20and%20cold%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20foggy%20harbor%20at%20dawn%20with%20silhouettes%20of%20boats%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20mist%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-06&orientation=landscape",
    synopsis:
      "一桩发生在码头仓库里的旧案，把三个原本毫无交集的人重新绑在一起。随着调查深入，真相像海雾一样层层涌来，没有谁是纯粹的受害者，也没有谁是彻底的恶人。",
    tags: ["案件", "人性", "港口", "冷峻"],
    reviews: [
      {
        id: "6-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 7.9,
        title: "冷是它的底色",
        content:
          "影片的灰蓝色调压得人喘不过气，但正是这种冷，让结尾那一点微光显得格外珍贵。剧本扎实，人物动机清晰。",
        date: "2021-09-10",
      },
      {
        id: "6-2",
        author: "观众·杜衡",
        role: "悬疑片爱好者",
        rating: 8.0,
        title: "没有绝对的好人与坏人",
        content:
          "喜欢它对『灰色』的处理，每个人都在自己的处境里做出选择。看完会忍不住想，如果是自己会怎么做。",
        date: "2021-09-22",
      },
      {
        id: "6-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 7.8,
        title: "氛围大于情节的稳健之作",
        content:
          "美术与摄影撑起了整部电影的质感，叙事节奏稍缓，但情绪积累到位后，力量感很足。",
        date: "2021-10-02",
      },
    ],
  },
  {
    id: "7",
    title: "第七个夏天",
    enTitle: "The Seventh Summer",
    year: 2024,
    director: "何蔚然",
    cast: ["夏栀", "顾清和", "陆时年", "许澄"],
    genres: ["家庭", "剧情", "文艺"],
    region: "中国大陆",
    duration: 115,
    rating: 8.3,
    tagline: "每一个夏天，都是这个家最后一次完整的夏天。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20an%20old%20house%20with%20green%20shutters%20in%20summer%20sunlight%2C%20warm%20nostalgic%20yet%20melancholic%20lighting%2C%20deep%20navy%20blue%20and%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20family%20house%20garden%20on%20a%20lazy%20summer%20afternoon%2C%20warm%20golden%20light%20with%20long%20shadows%2C%20navy%20and%20amber%20tones%2C%20nostalgic%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-07&orientation=landscape",
    synopsis:
      "一个普通家庭连续七个夏天都在同一栋老屋度过假期。第七个夏天，父母决定卖掉房子。四个孩子回到这里，试图在最后一段时间里，把那些说不清的爱与遗憾重新安放。",
    tags: ["家庭", "回忆", "告别", "群像"],
    reviews: [
      {
        id: "7-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.4,
        title: "把告别拍成了一整个夏天",
        content:
          "这是那种看完会想给家里打个电话的电影。它不回避家庭的裂痕，却始终相信温柔的力量。群像调度从容，每个孩子都有自己的弧光。",
        date: "2024-07-12",
      },
      {
        id: "7-2",
        author: "观众·林珊",
        role: "普通影迷",
        rating: 8.2,
        title: "眼眶热了好几次",
        content:
          "没有大起大落，就是一家人吃饭、修屋顶、吵架、和好。正因为平凡，才格外戳心。老屋的镜头一出现我就破防了。",
        date: "2024-07-25",
      },
      {
        id: "7-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.3,
        title: "时间是最好的叙事者",
        content:
          "七个夏天的结构看似重复，实则每一年的细节都在推动关系变化。这种耐心的写法，在当下的电影里越来越少见了。",
        date: "2024-08-03",
      },
    ],
  },
  {
    id: "8",
    title: "无声告白",
    enTitle: "Silent Confession",
    year: 2023,
    director: "叶疏桐",
    cast: ["程以宁", "沈知寒", "顾念"],
    genres: ["剧情", "爱情", "悬疑"],
    region: "中国大陆",
    duration: 108,
    rating: 8.1,
    tagline: "有些真相，等你说出口时，已经太晚了。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20woman%20standing%20alone%20in%20a%20quiet%20room%20with%20soft%20window%20light%2C%20melancholic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20an%20empty%20sunlit%20apartment%20with%20sheer%20curtains%20moving%2C%20soft%20cool%20light%2C%20navy%20and%20amber%20tones%2C%20quiet%20melancholic%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-08&orientation=landscape",
    synopsis:
      "一位听力渐渐衰退的女子选择对家人隐瞒病情，独自承受生活的失重。直到一场意外的误会，让所有人被迫面对彼此多年来的沉默。原来最深的心事，从来都不是听不见，而是不敢说。",
    tags: ["倾听", "隐瞒", "家庭", "细腻"],
    reviews: [
      {
        id: "8-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.1,
        title: "关于『听不见』与『不愿听』",
        content:
          "影片用听觉的失去，隐喻了人与人之间的沟通困境。女主角的表演层次分明，把一个不愿麻烦别人的倔强女性演得令人心疼。",
        date: "2023-06-15",
      },
      {
        id: "8-2",
        author: "观众·孟夏",
        role: "普通影迷",
        rating: 8.0,
        title: "安静的爆发力",
        content:
          "整部片子几乎没有大声的争吵，可每次沉默都像一记重拳。中间那段无声的独白，是全片最打动我的地方。",
        date: "2023-06-28",
      },
      {
        id: "8-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.2,
        title: "声音设计是隐藏的主角",
        content:
          "本片对音效的处理非常讲究，随着主角听力下降，环境音也一层层被剥离，这种沉浸式的表达非常难得。",
        date: "2023-07-09",
      },
    ],
  },
  {
    id: "9",
    title: "逆光而行",
    enTitle: "Walking Against the Light",
    year: 2022,
    director: "季川",
    cast: ["聂川", "卫青", "苏黎", "方决"],
    genres: ["剧情", "都市", "青春"],
    region: "中国大陆",
    duration: 119,
    rating: 7.7,
    tagline: "当所有人都劝你回头，你偏要迎着光往前走。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20young%20person%20walking%20toward%20bright%20light%20in%20an%20alley%2C%20hopeful%20dramatic%20backlight%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20sunlit%20city%20alley%20with%20strong%20backlight%20and%20long%20shadows%2C%20warm%20amber%20and%20navy%20tones%2C%20hopeful%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-09&orientation=landscape",
    synopsis:
      "小镇青年带着一台旧相机来到大城市，想成为一名纪实摄影师。理想被现实反复撞击，他一次次被劝退，又一次次选择逆着光走下去。这不是一个成功的故事，而是一个不肯放弃的故事。",
    tags: ["理想", "奋斗", "摄影", "励志"],
    reviews: [
      {
        id: "9-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 7.7,
        title: "不给鸡汤的现实励志",
        content:
          "影片没有把主角塑造成天才，他犯过错、也动摇过。正因如此，最后的坚持才显得可信而珍贵。",
        date: "2022-05-18",
      },
      {
        id: "9-2",
        author: "观众·江野",
        role: "普通影迷",
        rating: 7.6,
        title: "适合迷茫的时候看",
        content:
          "不是那种打鸡血的电影，更像一个朋友在旁边说：慢一点也没关系。摄影题材的镜头拍得很美。",
        date: "2022-05-29",
      },
      {
        id: "9-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 7.8,
        title: "关于坚持的另一种写法",
        content:
          "它承认了现实的坚硬，也保留了那一点点不肯熄灭的光。结尾没有奇迹，却让人心里发热。",
        date: "2022-06-06",
      },
    ],
  },
  {
    id: "10",
    title: "老街餐厅",
    enTitle: "The Old Street Diner",
    year: 2024,
    director: "温故",
    cast: ["鲁敬", "乔安", "简宁", "何时"],
    genres: ["家庭", "剧情", "喜剧"],
    region: "中国大陆",
    duration: 110,
    rating: 8.0,
    tagline: "一家开了三十年的小馆，装下了整条街的悲欢。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20cozy%20small%20restaurant%20on%20an%20old%20street%20at%20night%2C%20warm%20inviting%20lighting%2C%20deep%20navy%20blue%20and%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20warm%20small%20diner%20interior%20with%20hanging%20lights%20and%20steam%2C%20amber%20and%20navy%20tones%2C%20cozy%20nostalgic%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-10&orientation=landscape",
    synopsis:
      "老街要改造了，经营了三十年的小餐厅面临关门的命运。老板、厨师、老顾客，每个人都在这间小馆里留下了自己的故事。最后的营业夜，所有人聚在一起，好好吃了一顿也许再也吃不到的饭。",
    tags: ["美食", "人情", "小人物", "温情"],
    reviews: [
      {
        id: "10-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.0,
        title: "一碗热汤里的人情味",
        content:
          "影片把食物的温度和人情的温度绑在一起，看着看着就饿了，也看着看着就湿了眼眶。群像自然，笑中带泪。",
        date: "2024-03-10",
      },
      {
        id: "10-2",
        author: "观众·蔡禾",
        role: "普通影迷",
        rating: 8.1,
        title: "充满烟火气的好片",
        content:
          "最喜欢那些吃饭的镜头，没有一句大道理，却把『家』这个字讲得明明白白。适合全家一起看。",
        date: "2024-03-22",
      },
      {
        id: "10-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 7.9,
        title: "城市变迁中的温柔注脚",
        content:
          "它没有激烈地控诉时代，只是安静地记录那些即将消失的日常。这种含蓄，反而更有力量。",
        date: "2024-04-01",
      },
    ],
  },
  {
    id: "11",
    title: "失落的胶片",
    enTitle: "The Lost Reel",
    year: 2021,
    director: "顾长川",
    cast: ["柯铭", "许知遥", "南屏"],
    genres: ["悬疑", "文艺", "剧情"],
    region: "中国大陆",
    duration: 123,
    rating: 7.6,
    tagline: "一段失踪的胶片，藏着一个被遗忘的名字。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20an%20old%20film%20reel%20and%20projector%20in%20a%20dark%20archival%20room%2C%20moody%20nostalgic%20lighting%2C%20deep%20navy%20blue%20and%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dusty%20film%20archive%20room%20with%20shelves%20of%20cans%20and%20a%20projector%20beam%2C%20amber%20and%20navy%20tones%2C%20mysterious%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-11&orientation=landscape",
    synopsis:
      "一位电影修复师在整理旧片时，发现了一部没有署名的残缺影片。越是搜寻资料，她越觉得这段胶片背后隐藏着一段被刻意抹去的往事。当真相浮出水面，她要面对的不只是历史，还有自己家族的名字。",
    tags: ["胶片", "考证", "记忆", "文艺悬疑"],
    reviews: [
      {
        id: "11-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 7.6,
        title: "写给电影的一封情书",
        content:
          "影片对胶片时代的怀念藏在每个细节里，修复师的手、放映机的光、摇摇欲坠的档案架，都带着温度。故事略慢，但气质迷人。",
        date: "2021-11-08",
      },
      {
        id: "11-2",
        author: "观众·闻笛",
        role: "影迷",
        rating: 7.5,
        title: "适合安静地慢慢看",
        content:
          "很喜欢它把悬疑和怀旧揉在一起的方式。虽然节奏偏慢，但那种一点点揭开尘封记忆的感觉很上瘾。",
        date: "2021-11-19",
      },
      {
        id: "11-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 7.7,
        title: "关于『谁记得』的追问",
        content:
          "电影真正想问的是：当所有人都忘了，一段记忆还算存在吗？这个问题比案件本身更让人回味。",
        date: "2021-11-30",
      },
    ],
  },
  {
    id: "12",
    title: "明日之前",
    enTitle: "Before Tomorrow",
    year: 2024,
    director: "商砚",
    cast: ["叶知秋", "陆沉舟", "安夏"],
    genres: ["科幻", "剧情", "爱情"],
    region: "中国大陆",
    duration: 132,
    rating: 8.2,
    tagline: "如果明天不会到来，你今晚会做什么？",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20couple%20silhouetted%20against%20a%20glowing%20horizon%20at%20night%2C%20epic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20palette%2C%20film%20grain%20texture%2C%20elegant%20negative%20space%2C%20professional%20key%20visual%2C%20high%20detail%2C%20atmospheric%20background&width=600&height=900&seq=m-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20vast%20night%20sky%20over%20a%20quiet%20city%20with%20a%20faint%20glowing%20horizon%2C%20deep%20navy%20and%20amber%20tones%2C%20contemplative%20mood%2C%20film%20grain%2C%20professional%20cinematography%2C%20high%20detail&width=1600&height=900&seq=m-back-12&orientation=landscape",
    synopsis:
      "一颗未知天体被预测将在一天后掠过地球，没有人确定会发生什么。在这最后的二十四小时里，不同的人做出了不同的选择：有人回家，有人告白，有人继续工作。当黎明的光终于亮起，他们才发现，真正改变的不是世界，而是自己。",
    tags: ["末日前夕", "选择", "群像", "温柔科幻"],
    reviews: [
      {
        id: "12-1",
        author: "影评人·沈云初",
        role: "资深影评人",
        rating: 8.3,
        title: "用末日谈日常的珍贵",
        content:
          "影片几乎没有灾难奇观，而是把镜头对准普通人的最后一晚。正是这种克制，让『活着』这两个字变得沉甸甸的。",
        date: "2024-10-05",
      },
      {
        id: "12-2",
        author: "观众·罗一",
        role: "科幻爱好者",
        rating: 8.1,
        title: "科幻外壳，情感内核",
        content:
          "设定不算新奇，但处理得很温柔。最后那段黎明前街道的长镜头，可能是我今年看过最美的画面。",
        date: "2024-10-12",
      },
      {
        id: "12-3",
        author: "撰稿人·梁砾",
        role: "影视文化撰稿",
        rating: 8.2,
        title: "在终点前重新理解开始",
        content:
          "它让你思考：如果时间只剩一天，你真正在意的是什么？看完之后，很难不重新审视自己的生活。",
        date: "2024-10-14",
      },
    ],
  },
];

export const allGenres: string[] = [
  "剧情",
  "爱情",
  "悬疑",
  "犯罪",
  "文艺",
  "家庭",
  "科幻",
  "喜剧",
  "都市",
  "青春",
  "惊悚",
];